import React from "react"
import "./AboutPage.css"

const AboutPage = () => {
  return (
    <div className="epw-about-page">

      <main>
        <header className="epw-about-hero">
          <div className="epw-wrap">
            <p className="epw-eyebrow">About EnergyPulseWorld</p>
            <h1>Connecting Energy, Industry and Trade</h1>
            <p>
              EnergyPulseWorld turns complex energy, economic and trade developments into
              practical intelligence for organizations navigating changing costs, markets and risks.
            </p>
          </div>
        </header>

        <section className="epw-about-main">
          <div className="epw-wrap">

            <section className="epw-intro">
              <div>
                <p className="epw-section-label">Our Purpose</p>
                <h2>From market signals to business relevance.</h2>
              </div>

              <div className="epw-intro-copy">
                <p>
                  Energy markets do not move in isolation. Changes in oil, gas and electricity
                  can quickly affect inflation, industrial costs, fertilizers, steel, cement,
                  transport, trade flows and investment decisions.
                </p>
                <p>
                  EnergyPulseWorld brings these connections together through structured country
                  intelligence and premium weekly analysis, helping users understand not only
                  <strong> what is changing</strong>, but also <strong>why it matters</strong>.
                </p>
              </div>
            </section>

            <section className="epw-pillars">
              <div className="epw-section-head">
                <p className="epw-section-label">What We Cover</p>
                <h2>Four connected intelligence pillars</h2>
                <p>
                  A focused view of the economic, energy and trade factors shaping industrial markets.
                </p>
              </div>

              <div className="epw-pillar-grid">
                <article className="epw-card">
                  <span className="epw-card-number">01</span>
                  <h3>Macroeconomics</h3>
                  <p>GDP growth, CPI and PPI inflation, and foreign direct investment trends.</p>
                </article>

                <article className="epw-card">
                  <span className="epw-card-number">02</span>
                  <h3>Energy Mix</h3>
                  <p>Country power-generation structures across fossil and non-fossil sources.</p>
                </article>

                <article className="epw-card">
                  <span className="epw-card-number">03</span>
                  <h3>Commodity Markets</h3>
                  <p>Monthly movements in energy and energy-sensitive products including oil, gas, urea, ammonia, steel and cement.</p>
                </article>

                <article className="epw-card">
                  <span className="epw-card-number">04</span>
                  <h3>Trade Environment</h3>
                  <p>Import exposure, licensing, customs administration and practical market-access indicators.</p>
                </article>
              </div>
            </section>

            <section className="epw-insights">
              <div>
                <p className="epw-section-label">Premium Weekly Insights</p>
                <h2>Global developments. Regional impact.</h2>
                <p>
                  Our weekly reports connect major energy developments with their implications
                  for industry and trade, with dedicated analysis for Asia, the Middle East and
                  North Africa, and Sub-Saharan Africa.
                </p>
              </div>

              <a className="epw-cta" href="/reports">Explore Weekly Insights</a>
            </section>

            <section className="epw-closing">
              <strong>Energy. Economy. Industry. Trade.</strong>
              <p>
                One connected view to support better-informed market, investment and strategic decisions.
              </p>
            </section>

          </div>
        </section>
      </main>
    </div>
  )
}

export default AboutPage
